import { render, staticRenderFns } from "./topNotice.vue?vue&type=template&id=467dbfec&scoped=true"
import script from "./topNotice.vue?vue&type=script&lang=js"
export * from "./topNotice.vue?vue&type=script&lang=js"
import style0 from "./topNotice.vue?vue&type=style&index=0&id=467dbfec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467dbfec",
  null
  
)

export default component.exports